import Vue from 'vue';
//@ts-ignore
import VueHtml2pdf from 'vue-html2pdf';

Vue.use(VueHtml2pdf);
